import { useState, useEffect } from "react";
import api from "../../services/api";

interface AuthenticatedImageProps {
  fileName: string;
  alt: string;
  className?: string;
  onError?: () => void;
  professionalId?: string;
}

export default function AuthenticatedImage({
  fileName,
  alt,
  className,
  professionalId = "all_view",
}: AuthenticatedImageProps) {
  const [src, setSrc] = useState<string>("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    let objectUrl: string | null = null;

    const fetchImage = async () => {
      if (!fileName) {
        setLoading(false);
        return;
      }

      // Se já for uma URL completa (http/https) ou Data URI / Blob, usa diretamente
      if (
        fileName.startsWith("http://") ||
        fileName.startsWith("https://") ||
        fileName.startsWith("data:") ||
        fileName.startsWith("blob:") ||
        fileName.startsWith("static/") ||
        fileName.includes("static/media")
      ) {
        setSrc(fileName);
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        setError(false);
        const response = await api.get(
          `/images/download-public/${fileName}`,
          {
            responseType: "blob",
          }
        );

        objectUrl = URL.createObjectURL(response.data);
        setSrc(objectUrl);
      } catch (err) {
        console.error("Error fetching image:", err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchImage();

    return () => {
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [fileName]);

  if (loading) {
    return (
      <div
        className={`animate-pulse bg-gray-200 dark:bg-gray-700 ${className}`}
      />
    );
  }

  if (error || !src) {
    return (
      <img
        src="https://placehold.co/400x300/e2e8f0/1e293b?text=Imagem+Indisponível"
        alt={alt}
        className={className}
      />
    );
  }

  return <img src={src} alt={alt} className={className} />;
}
